import { Alert, ConfigProvider } from 'antd';

import styles from './AppAlert.module.scss';

const colorTextMap = {
  warning: '#B57701',
  // error: '#B57701',
  // info: '#B57701',
  // success: '#B57701',
};

const AppAlert = ({ message, prefix = 'Note:', type, ...alertProps }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorWarningBorder: '#FFA700',
          colorWarningBg: '#FFF6E6',
          colorText: colorTextMap[type],
        },
      }}
    >
      <Alert
        {...alertProps}
        type={type}
        message={
          <div className={styles.messageContainer}>
            {prefix && <span className={styles.note}>{prefix}</span>}
            <span className={styles.message}>{message}</span>
          </div>
        }
      />
    </ConfigProvider>
  );
};

export default AppAlert;
